const Nosotros = () =>{
    return(
        <h2>Nosotros</h2>
    )
}

export default Nosotros